// Libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import moment from 'moment';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import BookingService from 'services/BookingService';
import TextHelpers from 'helpers/TextHelpers';

// Components
import Loader from 'components/common/Loader';
import PageHeader from 'components/common/PageHeader';

//-------------------------------------------------------------------------------------------------------------------

class UnbilledDaysPage extends React.Component {

    constructor(props) {
        super(props);

        this.requestID = 1;
        this.state = {
            isLoading: true
        };
    }
    
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.load();
    }

    async load() {
        GlobalStateService.setValues({
            area: 'unbilled-days'
        });
        const unbilledDays = await BookingService.listUnbilledDays();
        this.setState({
            unbilledDays,
            isLoading: false
        });
    }

    render() {
        const {
            isLoading
        } = this.state;

        return (
            <div className="page unbilled-days-page">

                <PageHeader>
                    <h1>Unbilled days</h1>
                </PageHeader>

                <main>

                    <Container>

                        <section>

                            {this.renderInner()}

                        </section>

                    </Container>

                </main>

            </div>
        );
    }

    renderInner() {
        const {
            isLoading,
            unbilledDays
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        if (unbilledDays.length == 0) {
            return (
                <div className="empty-text">
                    No unbilled days to show
                </div>
            );
        }

        return (
            <div className="sticky-table-container scrolling">
                <table className="table table-bordered sticky-table selectable unbilled-days-table">
                    <thead>
                        <tr>
                            <th>Instructor</th>
                            <th>Date</th>
                            <th>Original Booking</th>
                            <th>New Booking</th>
                            <th>Reason</th>
                        </tr>
                    </thead>
                    <tbody>
                        {unbilledDays.map(ud =>
                            <tr key={ud.id}>
                                <td>{TextHelpers.formatInstructorName(ud.instructor)}</td>
                                <td>{moment(ud.date).format('DD/MM/YYYY')}</td>
                                <td>{ud.originalBooking.lmsid}</td>
                                <td>{ud.newBooking.lmsid}</td>
                                <td>{ud.reason}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default withRouter(UnbilledDaysPage);